"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CatalystClient = void 0;

var dcl_catalyst_commons_1 = require("dcl-catalyst-commons");

var Helper_1 = require("./utils/Helper");

var ContentClient_1 = require("./ContentClient");

var LambdasClient_1 = require("./LambdasClient");

var CatalystClientBuilder_1 = require("./utils/CatalystClientBuilder");

var CatalystClient = /*#__PURE__*/function () {
  function CatalystClient(catalystUrl, origin, // The name or a description of the app that is using the client
  fetcher) {
    _classCallCheck(this, CatalystClient);

    this.catalystUrl = Helper_1.sanitizeUrl(catalystUrl);
    fetcher = fetcher !== null && fetcher !== void 0 ? fetcher : new dcl_catalyst_commons_1.Fetcher({
      headers: Helper_1.getHeadersWithUserAgent('catalyst-client')
    });
    this.contentClient = new ContentClient_1.ContentClient(this.catalystUrl + '/content', origin, fetcher);
    this.lambdasClient = new LambdasClient_1.LambdasClient(this.catalystUrl + '/lambdas', fetcher);
  }

  _createClass(CatalystClient, [{
    key: "deployEntity",
    value: function deployEntity(deployData) {
      var fix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var options = arguments.length > 2 ? arguments[2] : undefined;
      return this.contentClient.deployEntity(deployData, fix, options);
    }
  }, {
    key: "fetchEntitiesByPointers",
    value: function fetchEntitiesByPointers(type, pointers, options) {
      return this.contentClient.fetchEntitiesByPointers(type, pointers, options);
    }
  }, {
    key: "fetchEntitiesByIds",
    value: function fetchEntitiesByIds(type, ids, options) {
      return this.contentClient.fetchEntitiesByIds(type, ids, options);
    }
  }, {
    key: "fetchEntityById",
    value: function fetchEntityById(type, id, options) {
      return this.contentClient.fetchEntityById(type, id, options);
    }
  }, {
    key: "fetchAuditInfo",
    value: function fetchAuditInfo(type, id, options) {
      return this.contentClient.fetchAuditInfo(type, id, options);
    }
  }, {
    key: "fetchContentStatus",
    value: function fetchContentStatus(options) {
      return this.contentClient.fetchContentStatus(options);
    }
  }, {
    key: "fetchAllDeployments",
    value: function fetchAllDeployments(deploymentOptions, options) {
      return this.contentClient.fetchAllDeployments(deploymentOptions, options);
    }
  }, {
    key: "streamAllDeployments",
    value: function streamAllDeployments(deploymentOptions, options) {
      return this.contentClient.streamAllDeployments(deploymentOptions, options);
    }
  }, {
    key: "isContentAvailable",
    value: function isContentAvailable(cids, options) {
      return this.contentClient.isContentAvailable(cids, options);
    }
  }, {
    key: "downloadContent",
    value: function downloadContent(contentHash, options) {
      return this.contentClient.downloadContent(contentHash, options);
    }
  }, {
    key: "pipeContent",
    value: function pipeContent(contentHash, writeTo, options) {
      return this.contentClient.pipeContent(contentHash, writeTo, options);
    }
  }, {
    key: "fetchProfiles",
    value: function fetchProfiles(ethAddresses, profileOptions, options) {
      return this.lambdasClient.fetchProfiles(ethAddresses, profileOptions, options);
    }
  }, {
    key: "fetchWearables",
    value: function fetchWearables(filters, options) {
      return this.lambdasClient.fetchWearables(filters, options);
    }
  }, {
    key: "fetchOwnedWearables",
    value: function fetchOwnedWearables(ethAddress, includeDefinitions, options) {
      return this.lambdasClient.fetchOwnedWearables(ethAddress, includeDefinitions, options);
    }
  }, {
    key: "fetchCatalystsApprovedByDAO",
    value: function fetchCatalystsApprovedByDAO(options) {
      return this.lambdasClient.fetchCatalystsApprovedByDAO(options);
    }
  }, {
    key: "fetchLambdasStatus",
    value: function fetchLambdasStatus(options) {
      return this.lambdasClient.fetchLambdasStatus(options);
    }
  }, {
    key: "getCatalystUrl",
    value: function getCatalystUrl() {
      return this.catalystUrl;
    }
  }, {
    key: "getContentUrl",
    value: function getContentUrl() {
      return this.contentClient.getContentUrl();
    }
  }, {
    key: "getLambdasUrl",
    value: function getLambdasUrl() {
      return this.lambdasClient.getLambdasUrl();
    }
  }], [{
    key: "connectedToCatalystIn",
    value: function connectedToCatalystIn(network, origin) {
      return CatalystClientBuilder_1.clientConnectedToCatalystIn(network, origin);
    }
  }]);

  return CatalystClient;
}();

exports.CatalystClient = CatalystClient;